import axios from 'axios'
import auth from '../../auth'

const baseURL = `${process.env.VUE_APP_API_URL}/api/v4`

const instance = axios.create({
  baseURL,
  headers: {
    post: {
      'Content-Type': 'application/json',
    },
  },
})

// Augment the request
instance.interceptors.request.use(async req => {
  const { access_token } = await auth.getUserRedirect()
  req.headers['Authorization'] = `Bearer ${access_token}`
  return req
})

export default instance
